import React from "react";
import { Header } from "./Header";
import { Typography } from "@mui/material";

interface PageHeaderProps {
  title: string;
  body?: string[];
}

export function PageHeader({ title, body }: PageHeaderProps) {
  return (
    <Header>
      <Typography
        variant={"h5"}
        sx={{
          marginY: !body ? "0.813rem" : undefined,
          fontWeight: 600,
        }}
      >
        {title}
      </Typography>
      {body &&
        body.map((text, idx) => (
          <Typography key={`${text[0]}-${idx}`} paragraph={true}>
            {text}
          </Typography>
        ))}
    </Header>
  );
}
